import {Injectable} from '@angular/core';
import {factory} from '../shared/app-logging';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {TtsApplicationDefaults} from '../model/ttsApplicationDefaults';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {ErrorDataService} from './error-data.service';
import {AppConfig} from '../shared/app-config';

const logger = factory.getLogger('TtsConfigService');

@Injectable({
  providedIn: 'root'
})
export class TtsConfigService {

  private ttsApplicationDefaults: { [sourceApp: string]: { [xcoreLocale: string]: Observable<TtsApplicationDefaults>; }; } = {};
  private ttsApplicationDefaultsLastCallError: { [sourceApp: string]: { [xcoreLocale: string]: boolean; }; } = {};

  constructor(private httpClient: HttpClient) {
  }

  public getTtsApplicationDefaults(xcoreLocale: string, sourceApp: string): Observable<TtsApplicationDefaults> {
    if (this.ttsApplicationDefaults[sourceApp] === undefined) {
      this.ttsApplicationDefaults[sourceApp] = {};
      this.ttsApplicationDefaultsLastCallError[sourceApp] = {};
    }
    if (this.ttsApplicationDefaults[sourceApp][xcoreLocale] && !this.ttsApplicationDefaultsLastCallError[sourceApp][xcoreLocale]) {
      logger.debug('getTtsApplicationDefaults: Cache hit.');
    }
    this.ttsApplicationDefaults[sourceApp][xcoreLocale] =
      (this.ttsApplicationDefaults[sourceApp][xcoreLocale] && !this.ttsApplicationDefaultsLastCallError[sourceApp][xcoreLocale]) ?
        this.ttsApplicationDefaults[sourceApp][xcoreLocale] :
        this.fetchTtsApplicationDefaults(xcoreLocale, sourceApp);
    return this.ttsApplicationDefaults[sourceApp][xcoreLocale];
  }

  private fetchTtsApplicationDefaults(xcoreLocale: string, sourceApp: string): Observable<TtsApplicationDefaults> {
    let urlService = AppConfig.urlTtsApplicationDefaultsByXcoreLocaleAndApplication;
    urlService = urlService.replace('{xcore_locale}', xcoreLocale);
    urlService = urlService.replace('{tts_application_name}', sourceApp);
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + urlService)
      .pipe(map(
        (response: HttpResponse<any>) => {
          if (response['data']) {
            logger.debug('getTtsApplicationDefaults: Data fetched from REST');
            this.ttsApplicationDefaultsLastCallError[sourceApp][xcoreLocale] = false;
            return TtsApplicationDefaults.parse(response['data']);
          }
        }
        ), catchError((err: Error | HttpErrorResponse) => {
          const message = `In TtsConfigService.getTtsApplicationDefaults().`;
          this.ttsApplicationDefaultsLastCallError[sourceApp][xcoreLocale] = true;
          return throwError(ErrorDataService.overLoadError(err, message));
        }),
        publishReplay(1),
        refCount());
  }
}
